export const containerHeight = 800;
export const defaultDeviationPercentage = 20;
export const defaultOpacity = 0.6;
export const defaultVoiceColor = '#808080';
export const fullOpacity = 1;
export const lowOpacity = 0.4;
export const lowerOpacity = 0.2;
export const minimumNodeRadius = 10;
export const maximumNodeRadius = 20;
